import { home } from './home'
import { rule } from './rule'
import { support } from './support'
import { works } from './works'

export {
  home,
  rule,
  support,
  works
}
